export default "__VITE_ASSET__BuX3g3d3__"